import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import ResourceSelect from "../../../../../../components/Inputs/ResourceSelect";
import { renderSettingsResourceLabel } from "../../../../../../utils/helpers/settings";
import { getSettingsResourceSearchFilters } from "../../../../../../utils/helpers/settings";

export const usePayGroupFilter = () => {
    const { t } = useTranslation();

    return useMemo(() => ({
        name: "payGroup",
        label: t("pay-group"),
        type: "resource-select",
        component: (
            <ResourceSelect
                labelPropName="description"
                resourcePath="/pay-group"
                renderLabel={renderSettingsResourceLabel}
                hasSearch
                mode="multiple"
                getSearchFilters={getSettingsResourceSearchFilters}
            />
        ),
    }), [t]);
}